export default "__VITE_ASSET__DN$7qAOc__"